<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item
                lines="none"
                mode="ios"
                class="title-with-back-button"
                style="margin-bottom: 5px;"
        >
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap" color="primary">
                {{ 'users.userVisibility' | translate | uppercase }}
            </ion-label>
        </ion-item>

        <ng-container *ngIf="user">
            <app-step-description
                    [description]="' '"
                    [employee]="{
                      imageUrl: getImageUrl(user.imageUrl),
                      username: user.name,
                      rank: user?.rank,
                      area: user?.area,
                      businessGroup: user?.businessGroup
                    }"
                    [showName]="true"
            ></app-step-description>

            <h4>{{ 'users.ruleByAttribute' | translate }}</h4>

            <div class="attributeRules">
                <ion-card
                        mode="ios"
                        class="team-card"
                        *ngFor="let rule of user.attributeRules"
                >
                    <h4>{{ rule.name }}</h4>
                    <ion-card-content class="ion-no-padding">
                        <ion-grid>
                            <ion-row>
                                <ion-col size="4">
                                    Tipo de Atributo
                                </ion-col>
                                <ion-col size="6">
                                    Nome do Atributo
                                </ion-col>
                                <ion-col size="2">
                                    Ação
                                </ion-col>
                            </ion-row>
                            <ion-row *ngFor="let condition of rule.conditions">
                                <ion-col size="4">
                                    {{ condition.type }}
                                </ion-col>
                                <ion-col size="6">
                                    {{ condition.name }}
                                </ion-col>
                                <ion-col
                                        size="2"
                                        [ngClass]="{ 'add': condition.include, 'delete': !condition.include }"
                                >
                                    {{ (condition.include ? 'Pode Ver' : 'Não pode ver') }}
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card-content>
                </ion-card>
            </div>

            <h4>
                {{ 'users.individualRule' | translate }}
                <ion-button
                        style="position: absolute; right: 20px; height: 35px; --border-radius:4px"
                        slot="end"
                        mode="ios"
                        color="primary"
                        (click)="export()"
                >
                    {{ 'generic.export' | translate }}
                </ion-button>
                <p style="position: absolute; right: 150px;" (click)="addRule()">
                    +
                </p>
            </h4>
            <ion-searchbar mode="ios"
                           class="section-search-custom"
                           [placeholder]="'generic.searchByName' | translate"
                           (keyup)="updateSearch($event.target.value)">
            </ion-searchbar>
            <app-individual-users-rule-list [user]="user"></app-individual-users-rule-list>
            <div class="load-more">
                <ion-item lines="none"
                          *ngIf="user?.userRules?.length < allUserRulesLength && user?.userRules?.length !== 0">
                    <ion-button (click)="loadUserRules()">{{ 'generic.loadMore' | translate }}</ion-button>
                </ion-item>
            </div>
        </ng-container>
    </div>
</ion-content>
